/**
 * Format numbers to English numerals (0-9) instead of Arabic numerals (٠-٩)
 * @param {number} num - The number to format
 * @param {object} options - Intl.NumberFormat options
 * @returns {string} - Formatted number string with English numerals
 */
export const formatNumber = (num, options = {}) => {
  if (num === null || num === undefined) return '';
  return new Intl.NumberFormat('en-US', options)?.format(num);
};

/**
 * Format currency in SAR with English numerals
 * @param {number} amount - The amount to format
 * @returns {string} - Formatted currency string
 */
export const formatCurrency = (amount) => {
  return formatNumber(amount, {
    style: 'decimal',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  });
};

/**
 * Format rating with one decimal place using English numerals
 * @param {number} rating - The rating to format
 * @returns {string} - Formatted rating string
 */
export const formatRating = (rating) => {
  return formatNumber(rating, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1
  });
};

export default formatNumber;